module.exports = __webpack_public_path__ + "media/category_icons/Cardiovascular-c96f1778.svg";